/* unplugin-vue-components disabled */import script from "./SubmitSuccessView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubmitSuccessView.vue?vue&type=script&lang=ts&setup=true"

import "./SubmitSuccessView.vue?vue&type=style&index=0&id=3464c317&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3464c317"]])

export default __exports__